const basePath = '/personal/exam-exercise/results'

export const ROUTER_PERSONAL_RESULT_EXAM_EXERCISE = {
	exam_result: id => (id ? `${basePath}/${id}` : `${basePath}/:id`)
}
